import React from "react";
import { Link as ScrollLink } from "react-scroll";
import { FaCircleArrowUp } from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <div className="flex justify-between text-black">
        <div className="">
          <p className="px-4 py-6 sm:px-10 sm:py-8 md:px-20 md:py-10">
            Made With ❤ by Manish Kumar
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
